<template>
    <div class="sorts">
        <sort :sortType="sortType" :chagneSortType="chagneSortType" :list="sortList" />
    </div>
     <div class="split-line"></div>
    <div class="item" v-for="item in list" :key="item.id">        
        <div class="title">
            <router-link :to="{path:'/essay_detail',query:{id:item.id,type:2}}" target="_blank">{{item.title}}</router-link>
        </div>
        <div class="journal-cover" v-if="item.jourImgUrl">
            <img :src="imgSiteUrl+item.jourImgUrl" alt="">
        </div>
        <div class="author">
            《{{item.journalNameZH}}》编辑部推荐 - {{item.pubYear}}年第{{item.period}}期发表
        </div>
         <router-link :to="{path:'/essay_detail',query:{id:item.id,type:2}}" target="_blank">
        <div class="desc">{{item.contentSummary}}</div>
        </router-link>
        <div class="keywords">
            <div class="count">
                <span class="browseCount"><i class="iconfont icon-liulan"></i>&nbsp;{{numWan(item.browseQua)}}&nbsp;</span>
                <span class="collectCount"><i class="iconfont icon-shoucang"></i>&nbsp;{{numWan(item.collectQua)}}&nbsp;</span>
                <span class="recCount"><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{numWan(item.praiseQua)}}&nbsp;</span>
            </div>
            <div>推荐日期：{{item.pubTime?item.pubTime.substring(0,10):''}}</div>
            <div class="clear"></div>
        </div>
    </div>
    <div class="page">
        <a-pagination :current="currentPage" show-quick-jumper :total="totals" @change="changePage" />
    </div>
</template>

<script>
import { defineComponent, reactive, toRefs, computed, watchEffect, onMounted, onBeforeUnmount } from "vue";
import Http from "../../until/http";
import { useRoute, useRouter } from "vue-router";
import Sort from "../../components/Sort.vue";
import config from "../../until/configs";
import { numWan } from "../../until/tools";

export default defineComponent({
    components: { Sort },
    setup() {
        const state = reactive({
            list:[],
            totals:0,
            filterVisible:false,
            recTime:0,
            pubYear:[],
            journal:[],
            directions:[],
            classifyGrouping:[],
            jourGrouping:[],
            currentYear:'',
            lastYear:'',
            sortList:[{value:0,title:'最近更新'},{value:1,title:'浏览最多'}],
            imgSiteUrl:config.imgSiteUrl
        })

        const route = useRoute();
        const router = useRouter();
        const currentPage = computed(()=>{
            let page = route.query.page;
            if(page) {
                return parseInt(page);
            }
            return 1;
        });
        const sortType = computed(()=>{
            let type = route.query.sort;
            if(type) {
                return parseInt(type);
            }
            return 0;
        });


        const changePage = (page)=>{
            router.push({path:'/expert_rec',query:{page:page,sort:sortType.value}});
        }

        watchEffect(()=>{
            let params = {
                pageNum:currentPage.value,
                sortType:sortType.value,
                recTime:state.recTime,
                pubYear:state.pubYear.join(','),
                jourId:state.journal.join(','),
                classify:state.directions.join(',')
            };
            Http.getEssayExpertRec(params).then(res=>{
                if(res) {
                    Object.assign(state,{
                        list:res.recommendations,
                        totals:res.condition.totalColumns
                    })
                    window.scrollTo(0,0);
                }
            });
        })

        const hideCondition = ()=>{
            Object.assign(state,{
                filterVisible:false
            })
        }

        const chagneSortType = (e)=>{
            router.push({path:'/expert_rec',query:{sort:e}});
        }


        onMounted(()=>{
            document.addEventListener('click',hideCondition);
            // Http.getRecConditions().then(res=>{
            //     Object.assign(state,{
            //         jourGrouping:res.jourGrouping,
            //         classifyGrouping:res.classifyGrouping
            //     })
            // });
            const date = new Date();
            const currentYear = date.getFullYear();
            const lastYear = currentYear-1;
            Object.assign(state,{
                currentYear,
                lastYear
            })
        })

        onBeforeUnmount(()=>{
            document.removeEventListener('click',hideCondition);
            
        })

        return {
            ...toRefs(state),
            changePage,
            sortType,
            currentPage,
            chagneSortType,
            numWan
        }
    }
})
</script>

<style>

</style>